import type { GA4Event } from '@/libs/ga4/types';

export const dataLayerPush = <T extends { event: Event | GA4Event }>(
  obj: T,
) => {
  if (typeof window !== 'undefined') {
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push(obj);
  }
};

export * from '@/libs/ga4/types';
export * from '@/libs/ga4/events';
